module.exports = "mutation setToClosed($closeInput:CloseInput!){setToClosed(closeInput:$closeInput)}"